var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12",attrs:{"id":"accordion"}},_vm._l((_vm.questions),function(question,key){return _c('div',{key:key},[_c('AccordionCard',{attrs:{"question-key":key,"question-details":question}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }